import { sync } from 'vuex-pathify';

import { Draw } from 'ol/interaction';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { getArea, getLength } from 'ol/sphere';

export default {
  computed: {
    isMeasurementsToolActive: sync('tools/toolStatus@isMeasurementsToolActive'),
  },
  methods: {
    clearMeasurementInteraction() {
      this.map.removeInteraction(this.getInteractionByName('measurement'));
      this.map.removeLayer(this.getLayerById('measurement'));
      this.isMeasurementsToolActive = false;
      this.activeTool = undefined;
      this.isActiveToolNotReplaceable = false;
    },
    formatArea(geometry) {
      const area = getArea(geometry);
      if (area > 1000000) {
        return `${Math.round((area / 1000000) * 100) / 100} km2`;
      } else if (area > 10000) {
        return `${Math.round((area / 10000) * 100) / 100} ha`;
      }
      return `${Math.round(area * 100) / 100} m2`;
    },
    formatLength(geometry) {
      const length = getLength(geometry);
      if (length > 1000) {
        return `${Math.round((length / 1000) * 100) / 100} km`;
      }
      return `${Math.round(length * 100) / 100} m`;
    },
    getPolygonMeasurementLabel(geometry) {
      return `${this.$i18n.t('map.area')}: ${this.formatArea(geometry)}
      ${this.$i18n.t('map.perimeter')}: ${this.formatLength(geometry)}`;
    },
    getMeasurementStyle(feature, type) {
      const geometry = feature.getGeometry();
      return [
        ...this.getPointMeasurementStyle(geometry),
        ...(type === 'Polygon' ? this.getAreaMeasurementStyles(geometry) : this.getLengthMeasurementStyles(geometry)),
      ];
    },
    addMeasurementLayer(type) {
      const layer = new VectorLayer({
        source: new VectorSource({}),
        id: 'measurement',
        style: feature => this.getMeasurementStyle(feature, type),
        zIndex: 1000,
      });
      this.map.addLayer(layer);
      return layer;
    },
    addMeasurement(type) {
      const drawLayer = this.addMeasurementLayer(type);
      this.addMeasurementInteraction(drawLayer, type);
    },
    addMeasurementInteraction(layer, type) {
      this.deactivateToolHandler();
      const measurementInteraction = new Draw({
        source: layer.getSource(),
        type: type,
        style: feature => this.getMeasurementStyle(feature, type),
      });
      measurementInteraction.set('name', 'measurement');
      measurementInteraction.on('drawstart', () => {
        this.getLayerById('measurement')
          .getSource()
          .clear();
      });
      this.map.addInteraction(measurementInteraction);
      this.isMeasurementsToolActive = true;
    },
    turnOffMeasurementsInteraction() {
      this.map.removeInteraction(this.getInteractionByName('measurement'));
    },
  },
  mounted() {
    /**
     * Methods with parameters has to be wrapped in order to not be executed
     * during proccess of attachment.
     */
    this.$root.$on('measurementArea-action', (value = true) => {
      if (value) {
        this.addMeasurement('Polygon');
        this.activeTool = 'measurementArea';
      } else {
        this.clearMeasurementInteraction();
      }
    });
    this.$root.$on('measurementLength-action', (value = true) => {
      if (value) {
        this.addMeasurement('LineString');
        this.activeTool = 'measurementLength';
      } else {
        this.clearMeasurementInteraction();
      }
    });
  },
};
